import { useCookies } from "react-cookie";

export function useCookie() {
  const [cookie, setCookie, removeCookie] = useCookies();

  return { cookie, setCookie, removeCookie }
}
